"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEditEmbed = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IconEditEmbed =
/*#__PURE__*/
function (_Component) {
  _inherits(IconEditEmbed, _Component);

  function IconEditEmbed() {
    _classCallCheck(this, IconEditEmbed);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconEditEmbed).apply(this, arguments));
  }

  _createClass(IconEditEmbed, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("svg", {
        className: "edit-embed",
        x: "0px",
        y: "0px",
        width: this.props.width ? this.props.width : "45px",
        viewBox: "538.2 311.5 245.8 179",
        enableBackground: "new 538.2 311.5 245.8 179",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react.default.createElement("g", null, _react.default.createElement("g", null, _react.default.createElement("polygon", {
        points: "613.5,452.5 561.1,400.1 613.5,347.7 623.5,357.8 581.2,400.1 623.5,442.4 \t\t"
      })), _react.default.createElement("g", null, _react.default.createElement("polygon", {
        points: "708.8,452.5 698.7,442.4 741,400.1 698.7,357.8 708.8,347.7 761.1,400.1 \t\t"
      })), _react.default.createElement("g", null, _react.default.createElement("rect", {
        x: "654",
        y: "327.5",
        transform: "matrix(0.9662 0.2578 -0.2578 0.9662 125.7392 -156.8963)",
        width: "14.2",
        height: "147"
      }))));
    }
  }]);

  return IconEditEmbed;
}(_react.Component);

exports.IconEditEmbed = IconEditEmbed;
//# sourceMappingURL=IconEditEmbed.js.map